import { useState, useEffect } from 'react';
import { apiFetch, buildQueryString } from '../lib/api';
import type { KommoFunnelData, KommoLead } from '../types';

interface Filters {
  startDate: string;
  endDate: string;
  service: string;
}

interface KommoData {
  funnel: KommoFunnelData | null;
  leads: KommoLead[];
  isLoading: boolean;
  error: string | null;
}

export function useKommoData(filters: Filters): KommoData {
  const [funnel, setFunnel] = useState<KommoFunnelData | null>(null);
  const [leads, setLeads] = useState<KommoLead[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);

    const qs = buildQueryString({
      startDate: filters.startDate,
      endDate: filters.endDate,
      service: filters.service !== 'all' ? filters.service : undefined,
    });

    Promise.all([
      apiFetch<KommoFunnelData>(`/api/metrics/kommo-funnel${qs}`),
      apiFetch<KommoLead[]>(`/api/metrics/kommo-leads${qs}`),
    ]).then(([f, l]) => {
      setFunnel(f);
      setLeads(l);
    }).catch(err => {
      setError(err instanceof Error ? err.message : 'Erro ao carregar dados');
    }).finally(() => {
      setIsLoading(false);
    });
  }, [filters.startDate, filters.endDate, filters.service]);

  return { funnel, leads, isLoading, error };
}
